import { ColorDynamic } from '@superdispatch/ui';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { useQuery } from 'shared/helpers/RoutingHelpers';
import { WebviewLayout } from 'shared/layout/WebviewLayout';
import { LimitedExperience } from 'shared/modules/shipper/LimitedExperienceDialog';
import { useShipperListHasLimitedExperience } from 'shared/modules/shipper/ShipperUtils';

export function ShipperLimitedExperienceScreen() {
  const [query] = useQuery();
  const guids = Array.isArray(query.guids) ? query.guids : [query.guids];
  const { experienceList } = useShipperListHasLimitedExperience(guids);

  return (
    <WebviewLayout backgroundColor={ColorDynamic.White}>
      {experienceList && (
        <LimitedExperience
          shippersExperience={experienceList}
          action="accept_offer"
          isFullHeight={true}
          isOpen={true}
          onConfirm={(doNotWarnAgain) => {
            MobileAppBridge.acceptShipperLimitedExperience(doNotWarnAgain);
          }}
        />
      )}
    </WebviewLayout>
  );
}
